// @flow
import React from "react";
import moment from "moment";
import _ from "lodash";
import Print from "rc-print";
import logoEn from "../../../images/logo/noon_en.svg";
import logoAr from "../../../images/logo/noon_ar.svg";
import Helper from "../../../helper/Helper";
import I18n from "../../../i18n/I18n";

const PrintInvoice = props => {
  const {
    printItems,
    setRef,
    currencyCode,
    lang,
    seller,
    warehouses,
    selectedWarehouse,
    status,
    selectedOrders,
    selectedWarehouseDetails
  } = props;
  let items = printItems ? printItems : [];
  const pr = [];
  if (!_.isEmpty(items) && !_.isEmpty(selectedOrders)) {
    for (let i = 0; i < items.length; i++) {
      for (let j = 0; j < selectedOrders.length; j++) {
        if (items[i].id_purchase_order_item === selectedOrders[j]) {
          pr.push(items[i]);
        }
      }
    }
  }
  items = pr && !_.isEmpty(pr) ? pr : items;
  let match = {};
  if (!_.isEmpty(items) && warehouses) {
    match = warehouses.find(
      warehouse => warehouse && warehouse.code === items[0].warehouse_code
    );
  }
  let title = I18n.getText("print.fulfilment-request");
  switch (status) {
    default:
    case 2:
      title = I18n.getText("print.fulfilment-request");
      break;
    case 3:
      title = I18n.getText("orders.ready-for-pickup");
      break;
  }

  const otherStyle = `
    @import url('https://fonts.googleapis.com/css?family=Cairo:200,400,700&subset=arabic,latin-ext');

             .ctr {
               font-family: ${
                 lang === "ar" ? "Cairo" : "Proxima Nova"
               }, sans-serif;

               color: #404553;
               background: yellow;
               padding: 10px 0;
               direction: ${lang === "ar" ? "rtl" : "ltr"};
             }
             .header {
               display: flex;
               align-items: center;
               justify-content: center;
               border-bottom: 1px solid #ebedee;
               padding: 20px 0;
               direction: ${lang === "ar" ? "rtl" : "ltr"};


             }
             .logoCtr {
               height: 45px;

             }
             .logo {
               height: 100%;
               width: auto;
             }
             .address {
               display: flex;
               align-items: flex-start;
               justify-content: space-between;
               font-family: ${
                 lang === "ar" ? "Cairo" : "Proxima Nova"
               }, sans-serif;
               color: #404553;
               direction: ${lang === "ar" ? "rtl" : "ltr"};

             }
             .title {
               font-size: 24px;
               font-weight: 400;
               padding: 0 0 15px 0;
               border-bottom: 1px solid #ebedee;
               font-family: ${
                 lang === "ar" ? "Cairo" : "Proxima Nova"
               }, sans-serif;

               color: #404553;
               direction: ${lang === "ar" ? "rtl" : "ltr"};

             }
             .lhs {
               width: 48%;
               direction: ${lang === "ar" ? "rtl" : "ltr"};
             }
             .each {
               display: flex;
               flex: 1;
               justify-content: space-between;
               direction: ${lang === "ar" ? "rtl" : "ltr"};
             }
             .each .val {
               direction: ${lang === "ar" ? "rtl" : "ltr"};
               margin: 5px;
               word-break: break-all;
             }
             .each .label {
               word-break: default;
               white-space: nowrap;
             }
             .printTable {
               width: 100%;
               margin: 20px 0;
               border-collapse: collapse;
               font-family: ${
                 lang === "ar" ? "Cairo" : "Proxima Nova"
               }, sans-serif;
               color: #404553;
               text-align: ${lang === "ar" ? "right" : "left"};
               font-size: 12px;
               direction: ${lang === "ar" ? "rtl" : "ltr"};

             }
             .tableHead {
               position: relative;
               font-size: 12px;
               background: #eeeeee;
               -webkit-print-color-adjust:exact;
             }
             .printTable td, .printTable th {
               padding: 10px;
               border-bottom: 1px solid #ebedee;
               direction: ${lang === "ar" ? "rtl" : "ltr"};
             }
             .printTable tr {
               direction: ${lang === "ar" ? "rtl" : "ltr"};

             }
             .noWrap {
               white-space: nowrap;
             }
             .attributes {
               font-size: 12px;
               color: #93939a;
               font-weight: unset;
               direction: ${lang === "ar" ? "rtl" : "ltr"};

             }
               .eachAttr {
                 margin-right: ${lang === "ar" ? "0" : "10px"};
                 margin-right: ${lang === "en" ? "10px" : "0"};
                 // white-space: nowrap;
                 direction: ${lang === "ar" ? "rtl" : "ltr"};

               }

               .bold {
                 font-weight: 600;
               }

               a {
                 color: #404553;
                 font-weight: 600;
                 direction: ${lang === "ar" ? "rtl" : "ltr"};

               }
               .number {
                 direction: ltr;
               }
               .val {
                 margin-right: ${lang === "ar" ? "0" : "10px"};
                 margin-left: ${lang === "ar" ? "10px" : "0"};
                 font-size: 12px;
               }
               .productTitle {
                 min-width: 100px;
               }
               .asnCtr {
                 display: flex;
                 align-items: center;
                 justify-content: flex-end;
                 padding: 10px 0;
               }
               .asnTitle {
                 font-size: 15px;
                  margin: 0 20px;
                  font-family: ${
                    lang === "ar" ? "Cairo" : "Proxima Nova"
                  }, sans-serif;
                  color: #404553;
               }
               .asnVal {
                 font-size: 15px;
                 font-weight: 600;
                 font-family: ${
                   lang === "ar" ? "Cairo" : "Proxima Nova"
                 }, sans-serif;
                 color: #404553;
               }

       `;

  const orderList =
    items && !_.isEmpty(items)
      ? items.map((order, index) => (
          <tr>
            <td className="noWrap">{order.partner_sku}</td>
            <td className="noWrap">{order.sku}</td>
            <td>
              <div className="productTitle">
                {order.title}
                <div className="attributes">
                  <span className="eachAttr">
                    <a>{order.brand}</a>
                  </span>
                  <span>
                    {order.variant ? (
                      <span className="eachAttr">
                        {I18n.getHtml("order-details.variant", {
                          variant: order.variant
                        })}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                  <span>
                    {order.model ? (
                      <span className="eachAttr">
                        {I18n.getHtml("order-details.model", {
                          model: order.model
                        })}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                  {order.attributes &&
                  !_.isEmpty(JSON.parse(order.attributes)) ? (
                    <span className="eachAttr">
                      {JSON.parse(order.attributes).colour_family ? (
                        <span>
                          {I18n.getHtml("order-details.color", {
                            color: JSON.parse(order.attributes).colour_family
                          })}
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </td>
            <td>{order.qty || "1"}</td>

            {selectedWarehouse !== 1 || items ? (
              ""
            ) : (
              <td>{order.warehouse_code || ""}</td>
            )}
          </tr>
        ))
      : "";
  return (
    <div>
      <Print
        ref={setRef}
        insertHead={false}
        ignoreHeadJs={false}
        title={lang === "ar" ? "الطلبيات" : "Orders"}
        otherStyle={otherStyle}
      >
        <div style={{ display: "none" }} className="ctr">
          <div className="header">
            <div className="logoCtr">
              <img
                src={lang === "ar" ? logoAr : logoEn}
                alt="logo"
                className="logo"
              />
            </div>
          </div>
          <h2 className="title">{title}</h2>
          <div className="address">
            <div className="lhs">
              <div className="each">
                <span className="val label">
                  {I18n.getText("print.partner-name")}
                  <span className="val">:</span>
                </span>
                <span className="val"> {seller.storeName}</span>
              </div>
              <div className="each">
                <span className="val label">
                  {I18n.getText("print.partner-tin")}
                  <span className="val">:</span>
                </span>
                <span className="val"> {seller.id_partner}</span>
              </div>
              {selectedWarehouse !== 1 || items ? (
                <div className="each">
                  <span className="val label">
                    {I18n.getText("print.contact-person")}
                    <span className="val">:</span>
                  </span>

                  <span className="val">
                    {selectedWarehouseDetails &&
                    selectedWarehouseDetails.contact_person
                      ? selectedWarehouseDetails.contact_person
                      : "-"}
                  </span>
                </div>
              ) : (
                ""
              )}
              <div className="each">
                <span className="val label">
                  {I18n.getText("credit.date")}
                  <span className="val">:</span>
                </span>
                <span className="val"> {moment().format(`YYYY-MM-DD`)}</span>
              </div>
            </div>
            {selectedWarehouse !== 1 || items ? (
              <div className="lhs">
                <div className="each">
                  <span className="val label">
                    {I18n.getText("print.phone")} <span className="val">:</span>
                  </span>

                  <span className="val number">
                    {" "}
                    {selectedWarehouseDetails &&
                    selectedWarehouseDetails.contact
                      ? selectedWarehouseDetails.contact
                      : "-"}
                  </span>
                </div>
                <div className="each">
                  <span className="val label">
                    {I18n.getText("print.pickup-city")}{" "}
                    <span className="val">:</span>
                  </span>

                  <span className="val">
                    {" "}
                    {selectedWarehouseDetails && selectedWarehouseDetails.city
                      ? selectedWarehouseDetails.city
                      : "-"}
                  </span>
                </div>
                <div className="each">
                  <span className="val label">
                    {I18n.getText("orders.warehouse")}{" "}
                    <span className="val">:</span>
                  </span>

                  <span className="val">
                    {" "}
                    {selectedWarehouseDetails && selectedWarehouseDetails.code
                      ? selectedWarehouseDetails.code
                      : "-"}
                  </span>
                </div>
                <div className="each">
                  <span className="val label">
                    {I18n.getText("print.pickup-address")}{" "}
                    <span className="val">:</span>
                  </span>

                  <span className="val">
                    {" "}
                    {selectedWarehouseDetails &&
                    selectedWarehouseDetails.address
                      ? selectedWarehouseDetails.address
                      : "-"}
                  </span>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          {items &&
            !_.isEmpty(items) &&
            items[0].asn_nr && (
              <div className="asnCtr">
                <h5 className="asnTitle">{I18n.getText("transfers.asn")}: </h5>
                <div className="asnVal">{items[0].asn_nr}</div>
              </div>
            )}
          <div>
            <table className="printTable">
              <thead>
                <tr className="tableHead">
                  <th>{I18n.getText("order-details.p-sku")}</th>
                  <th>{I18n.getText("order-details.sku")}</th>
                  <th>{I18n.getText("order-details.name")}</th>
                  <th>{I18n.getText("order-modal.qty")}</th>
                  {selectedWarehouse !== 1 || items ? (
                    ""
                  ) : (
                    <th>{I18n.getText("items.warehouse")}</th>
                  )}
                </tr>
              </thead>
              <tbody>{orderList}</tbody>
            </table>
          </div>
        </div>
      </Print>
    </div>
  );
};

export default PrintInvoice;



// WEBPACK FOOTER //
// ./src/components/stockRequest/print/PrintItems.js